import React, { Component } from 'react'

// Styles
import './col.scss'

class Col extends Component {
  getSpanClass () {
    return ' s-' + this.props.span
  }

  getStyle () {
    return 'element-column' + this.getSpanClass()
  }

  render () {
    return (
      <div className={this.getStyle()} id={this.props.id}>
        {this.props.children}
      </div>
    )
  }
}

Col.defaultProps = {
  span: 1,
  id: null
}

export default Col



// WEBPACK FOOTER //
// ./src/app/shared/elements/col/index.js